// components/ui/Badge.jsx
import React from 'react'
import { cn } from '../../lib/cn'

const tones = {
  neutral: 'bg-slate-100 text-slate-700 ring-slate-200',
  green: 'bg-emerald-50 text-emerald-700 ring-emerald-100',
  yellow: 'bg-amber-50 text-amber-700 ring-amber-100',
  blue: 'bg-sky-50 text-sky-700 ring-sky-100',
  red: 'bg-rose-50 text-rose-700 ring-rose-100',
  purple: 'bg-violet-50 text-violet-700 ring-violet-100',
}

export function Badge({ children, tone = 'neutral', className = '', icon: Icon }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ring-1',
        tones[tone],
        className
      )}
    >
      {Icon && <Icon className="h-3 w-3" />}
      {children}
    </span>
  )
}
